import { PastEssaySubmissionResponse } from './../../models/essay-pilot/pastEssaySubmissionResponse';
import { EssayAnswerRequest } from './../../models/essay-pilot/essayAnswer';
import { Observable, Subject } from 'rxjs';
import { EssayQuestionRequest } from '../../models/essay-pilot/essayQuestionRequest';
import { GenericService } from './../generic.service';
import { Injectable } from '@angular/core';
import { EssayQuestionResponse } from '../../models/essay-pilot/essayQuestionResponse';
import { EssayAnswerResponse } from '../../models/essay-pilot/essayAnswerResponse';
import { FindAnswerRequest } from '../../models/essay-pilot/findAnswerRequest';
import { apiResponse } from '../../models/apiResponse';
import { CommanEssayQuestion } from '../../models/essay-pilot/commanEssayQuestion';
import { PastEssaySubmissionRequest } from '../../models/essay-pilot/pastEssaySubmissionRequest';
import { CommanEssayQuestionRequest } from '../../models/essay-pilot/commonEssayQuestionRequest';
import { PastEssayQuestionRequest } from '../../models/essay-pilot/pastEssayQuestionRequest';
import { PastEssayQuestionResponse } from '../../models/essay-pilot/pastEssayQuestionResponse';
import { EssayCommentRequest } from '../../models/essay-pilot/essayCommentRequest';
import { GetEssayCommentRequest } from '../../models/essay-pilot/getEssayCommentRequest';
import { EssayCommentResponse } from '../../models/essay-pilot/essayCommentResponse';
import { SubmitEssayReviewRequest } from '../../models/essay-pilot/submitEsayReviewRequest';
import { GetEssayQuestionRequest } from '../../models/essay-pilot/getEssayQuestionRequest';

@Injectable({
  providedIn: 'root'
})
export class EssayPilotService {

  constructor(private genericService:GenericService) {

  }

  essayAnswerSubmission$ = new Subject<EssayAnswerResponse>();


  addInstituteQuestions(InstituteId:string,essayQuestionRequest:EssayQuestionRequest){
    return this.genericService.post(`essayquestion/${InstituteId}`,essayQuestionRequest);
  }

  addCommonEssayQuestion(commonQuestionRequest: CommanEssayQuestionRequest):Observable<CommanEssayQuestion>{
    return this.genericService.post('commanessayquestion',commonQuestionRequest);
  }

  updateCommonEssayQuestion(questionId: number, commonQuestionRequest: CommanEssayQuestionRequest):Observable<CommanEssayQuestion>{
    return this.genericService.put(`updatecommonessayquestion/${questionId}`,commonQuestionRequest);
  }

  deleteCommonEssayQuestion(questionId: number){
    return this.genericService.delete(`commanessayquestion/${questionId}`);
  }

  getInstituteQuestions(req:GetEssayQuestionRequest):Observable<EssayQuestionResponse>
  {
    return this.genericService.post(`essayquestion`, req);
  }

  saveStudentEssayAnswer(essayAnswerRequest:EssayAnswerRequest):Observable<EssayAnswerResponse>
  {
    return this.genericService.post('essayquestionresponse',essayAnswerRequest);
  }

  getStudentEssayAnswer(findAnswerRequest:FindAnswerRequest):Observable<EssayAnswerResponse>
  {
    return this.genericService.post('essayanswer/question',findAnswerRequest);
  }

  updateStudentEssayAnswer(essayAnswerId:string,essayAnswerRequest:EssayAnswerRequest):Observable<EssayAnswerResponse>
  {
    return this.genericService.put(`essayquestionresponse/${essayAnswerId}`,essayAnswerRequest);
  }

  getCommonEssayQuestions(courseLevel?: number, category?: number):Observable<apiResponse<CommanEssayQuestion[]>>
  {
    if (courseLevel !== undefined && category !== undefined) {
      return this.genericService.get(`commanessayquestion/${courseLevel}/${category}`);
    }
    return this.genericService.get('commanessayquestion');
  }

  getPastSubmissions(request:PastEssaySubmissionRequest):Observable<apiResponse<PastEssaySubmissionResponse[]>>
  {
    return this.genericService.post('pastessaysubmissions',request);
  }
  getPastEssayQuestions(request: PastEssayQuestionRequest):Observable<apiResponse<PastEssayQuestionResponse[]>>
  {
    return this.genericService.post('pastessayquestions', request);
  }
  getEssayComments(getEssayCommentRequest?: GetEssayCommentRequest): Observable<apiResponse<EssayCommentResponse[]>>
  {
    return this.genericService.post(`essaycomment/bystatus`, getEssayCommentRequest);
  }
  addEssayComment(essayCommentRequest: EssayCommentRequest): Observable<EssayCommentResponse>
  {
    return this.genericService.post(`essaycomment`, essayCommentRequest);
  }
  deleteEssayComment(commentId: number):Observable<EssayCommentResponse>
  {
    return this.genericService.delete(`essaycomment/${commentId}`);
  }
  updateCommentStatus(commentId: number): Observable<EssayCommentResponse>
  {
    return this.genericService.put(`essaycomment/${commentId}`,{});
  }
  postEssayReviewRequest(submitEssayReviewRequest: SubmitEssayReviewRequest): Observable<string>
  {
    return this.genericService.post('essayreview', submitEssayReviewRequest);
  }
}
